import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Box, Typography } from '@mui/material';
import SocialsButton from '../../components/SocialsButton';
import ResumeInfo from '../../components/ResumeInfo';

function EventContact({
  event: {
    contact: {
      email,
      phone,
      facebook,
      twitter,
      instagram,
      tiktok,
      youtube,
      linkedin,
    },
  },
}) {
  return (
    <>
      {email && (
        <ResumeInfo
          title={email}
          iconify="ic:baseline-mail-outline"
          onClick={() => {
            window.location.href = `mailto:${email}`;
          }}
        />
      )}
      {phone && (
        <ResumeInfo
          title={phone}
          iconify="mdi:phone-outline"
          onClick={() => {
            window.open(`tel:${phone}`);
          }}
        />
      )}
      <SocialsButton
        simple
        initialColor
        links={{ facebook, twitter, instagram, tiktok, youtube, linkedin }}
      />
    </>
  );
}

EventContact.propTypes = {
  event: PropTypes.object.isRequired,
};

export default EventContact;
